<mat-tab-group (selectedTabChange)="insightsTabChanged($event)">
    <mat-tab>
        <ng-template mat-tab-label>
            <span class="tab-icon"><i class="fa fa-truck fa-lg" aria-hidden="true"></i></span>
            Vehicle Statistics
        </ng-template>
        <div class="w-100" *ngIf="insightTabIndex===0">
            <app-vehicle-insight [tabData]="{entityId: entityId , attribute:'distance'}">
            </app-vehicle-insight>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span class="tab-icon"><i class="fa fa-truck fa-lg" aria-hidden="true"></i></span>
            Idiling Fuel
        </ng-template>
        <div class="w-100" *ngIf="insightTabIndex===1">
            <app-vehicle-insight [tabData]="{entityId: entityId , attribute:'idling'}">
            </app-vehicle-insight>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span class="tab-icon"><i class="fa fa-truck fa-lg" aria-hidden="true"></i></span>
            Distance chart
        </ng-template>
        <div class="w-100" *ngIf="insightTabIndex===2">
            <app-vehicle-insight [tabData]="{entityId: entityId , attribute:'distance'}">
            </app-vehicle-insight>
        </div>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span class="tab-icon"><i class="fa fa-truck fa-lg" aria-hidden="true"></i></span>
            Ride status
        </ng-template>
        <div class="w-100" *ngIf="insightTabIndex===3">
            <app-vehicle-insight [tabData]="{entityId: entityId}">
            </app-vehicle-insight>
        </div>
    </mat-tab>
</mat-tab-group>